module.exports = __webpack_public_path__ + "img/table-allergy.ff9171e4.svg";